import { createApiQuery } from '@/hooks/use-api-query';
import { get } from '@/libs/http';
import { type NotificationFetchwithmarkReq, type NotificationFetchwithmarkRes } from '@/types/api/vip/notification-fetchwithmark';

export const getNotificationFetchwithmark = ({ params }: { params: NotificationFetchwithmarkReq; }): Promise<NotificationFetchwithmarkRes> => {
  return get<NotificationFetchwithmarkRes>('/member/my/v1/notification/fetchwithmark', { params });
};

export const useNotificationFetchwithmark = createApiQuery(getNotificationFetchwithmark, (params) => ['notificationFetchwithmark', params]);  